import otherServices from '../../components/page-other-services/index';

export default [
    {
        path: '/other_service',
        name: 'other_service',
        component: () => import('../../views/other_services'),
        children: otherServices
    }
]